(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mucci-custom-design"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mucci-project-intake')) {
    customElements.define('mucci-project-intake', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-details]');
        const next = this.querySelector('[data-next]');
        const summary = this.querySelector('[data-summary]');
        const status = this.querySelector('[data-copy-status]');
        const heading = this.querySelector('[data-next-heading]');
        const french = this.dataset.language === 'fr';
        this.initializeUploads(form);
        form.querySelectorAll('[data-available]').forEach(button => { button.disabled = false; });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.uploadBusy) return;
          if (!form.reportValidity()) return;
          const mode = event.submitter?.value;
          if (mode !== 'meeting' && mode !== 'etsy') return;
          const data = new FormData(form);
          const service = form.elements.service.selectedOptions[0].textContent.trim();
          const value = key => String(data.get(key) || '').trim();
          if (!value('name') || !value('details')) {
            const field = !value('name') ? form.elements.name : form.elements.details;
            field.setCustomValidity(french ? 'Veuillez remplir ce champ.' : 'Please fill in this field.');
            field.reportValidity();
            return;
          }
          const chosen = this.querySelector('[data-upload-input]');
          if (!this.selectedFiles.length && chosen?.files?.length) this.selectedFiles = Array.from(chosen.files);
          // Draft and booking never start an upload. An automatic transfer spends the quota and hides its progress.
          if (this.selectedFiles.length && !this.emailBackup && !this.uploaded) {
            this.requireUpload();
            return;
          }
          this.projectReference ||= `MP-CUSTOM-${crypto.randomUUID().replaceAll('-', '').slice(0, 12).toUpperCase()}`;
          const subject = `${this.dataset.subjectPrefix} ${this.projectReference} — ${this.uploadLabels.keepName}`;
          this.querySelector('[data-project-reference]').textContent = this.projectReference;
          this.querySelector('[data-email-files]').href = `mailto:${this.dataset.filesEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`${subject}\n\n${this.dataset.emailBody}`)}`;
          const notificationStatus = this.querySelector('[data-notification-status]');
          notificationStatus.hidden = this.uploaded?.notification !== 'unavailable';
          notificationStatus.textContent = notificationStatus.hidden ? '' : this.uploadLabels.notificationError;
          summary.value = [
            `${this.dataset.subjectLabel}: ${subject}`, '',
            french ? 'Bonjour Mucci Products, voici mon projet :' : 'Hello Mucci Products, here is my project:',
            '', `${french ? 'Nom' : 'Name'}: ${value('name')}`,
            `${french ? 'Courriel' : 'Email'}: ${value('email')}`,
            `${french ? 'Service souhaité' : 'Service needed'}: ${service}`,
            '', french ? 'Description et exigences :' : 'Project description and requirements:',
            value('details'),
            '', ...(this.uploaded ? [
              `${this.uploadLabels.saved}: ${this.uploaded.count}`,
              `${this.uploadLabels.folder}: ${this.uploaded.reference}`,
              ...this.selectedFiles.map(file => `- ${file.name}`)
            ] : [this.dataset.draftNote])
          ].join('\n');
          this.querySelectorAll('[data-meeting]').forEach(element => { element.hidden = mode !== 'meeting'; });
          this.querySelectorAll('[data-etsy]').forEach(element => { element.hidden = mode !== 'etsy'; });
          heading.textContent = mode === 'meeting'
            ? (french ? '3. Copiez le résumé et choisissez une heure' : '3. Copy your summary and choose a time')
            : (french ? '3. Vérifiez votre brouillon Etsy' : '3. Review your Etsy draft');
          const calendar = this.querySelector('[data-calendar]');
          if (mode === 'meeting' && calendar && !calendar.hasAttribute('src')) calendar.src = calendar.dataset.src;
          status.textContent = '';
          next.hidden = false;
          heading.focus();
          next.scrollIntoView({ block: 'start' });
        });
        form.addEventListener('input', event => {
          event.target.setCustomValidity?.('');
          if (!this.uploadBusy) next.hidden = true;
        });
        this.querySelector('[data-edit]').addEventListener('click', () => {
          next.hidden = true;
          form.elements.details.focus();
          form.scrollIntoView({ block: 'start' });
        });
        this.querySelector('[data-copy]').addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(summary.value);
            status.textContent = french ? 'Résumé copié. Collez-le dans Google ou Etsy.' : 'Summary copied. Paste it into Google or Etsy.';
          } catch {
            summary.focus();
            summary.select();
            status.textContent = french ? 'Sélectionnez le texte et copiez-le manuellement.' : 'Select the text and copy it manually.';
          }
        });
      }
      initializeUploads(form) {
        const input = this.querySelector('[data-upload-input]');
        const button = this.querySelector('[data-upload-files]');
        const backup = this.querySelector('[data-email-backup]');
        const status = this.querySelector('[data-upload-status]');
        this.uploadLabels = { ...this.querySelector('[data-upload-copy]').dataset, ...this.querySelector('[data-upload-ui]').dataset };
        this.selectedFiles = [];
        this.fileStates = [];
        backup.disabled = false;
        const showStatus = message => {
          status.textContent = message;
          status.focus({ preventScroll: true });
          status.scrollIntoView({ block: 'center', behavior: 'smooth' });
        };
        const fileError = file => {
          const key = file.size > 20000000 ? 'sizeError' : !file.size ? 'emptyError' : file.name.length > 220 ? 'nameError' : null;
          return key ? this.uploadLabels[key].replace('[name]', file.name) : '';
        };
        const selectionError = () => [
          ...(this.selectedFiles.length > 10 ? [this.uploadLabels.countError.replace('[count]', String(this.selectedFiles.length))] : []),
          ...this.selectedFiles.map(fileError).filter(Boolean)
        ].join(' ');
        const cooldownMessage = () => {
          const cooldown = this.uploadCooldown;
          if (!cooldown || cooldown.until <= Date.now() || cooldown.email !== form.elements.email.value.trim().toLowerCase()) return '';
          return this.uploadLabels.rateLimit.replace('[time]', new Date(cooldown.until).toLocaleString(this.dataset.language === 'fr' ? 'fr-CA' : 'en-CA'));
        };
        const syncUploadButton = () => { button.disabled = this.uploadBusy || Boolean(selectionError()) || !this.selectedFiles.length || Boolean(cooldownMessage()); };
        this.requireUpload = () => showStatus(selectionError() || cooldownMessage() || this.uploadLabels.uploadFirst);
        const renderFiles = () => {
          const list = this.querySelector('[data-upload-list]');
          list.replaceChildren();
          this.selectedFiles.forEach((file, index) => {
            const item = document.createElement('li');
            const label = document.createElement('span');
            label.textContent = `${file.name} (${(file.size / 1000000).toFixed(2)} MB)`;
            const state = document.createElement('strong');
            state.dataset.fileStatus = this.fileStates[index] || 'waiting';
            state.textContent = fileError(file) || `${state.dataset.fileStatus === 'fileSaved' ? '✓ ' : ''}${this.uploadLabels[state.dataset.fileStatus]}`;
            state.setAttribute('role', 'status');
            const remove = document.createElement('button');
            remove.type = 'button'; remove.className = 'mucci-project__outline';
            remove.dataset.removeFile = String(index);
            remove.textContent = this.uploadLabels.removeFile;
            remove.setAttribute('aria-label', `${this.uploadLabels.removeFile}: ${file.name}`);
            remove.disabled = Boolean(this.uploadBusy);
            remove.addEventListener('click', () => {
              if (this.uploadBusy) return;
              this.selectedFiles.splice(index, 1);
              try {
                const remaining = new DataTransfer();
                this.selectedFiles.forEach(file => remaining.items.add(file));
                input.files = remaining.files;
              } catch { input.value = ''; }
              resetSelection();
              (list.querySelectorAll('button')[index] || list.querySelector('button') || input).focus();
            });
            item.append(label, state, remove); list.append(item);
          });
        };
        const resetSelection = () => {
          const hadSession = Boolean(this.uploadSession);
          this.uploadSession = null;
          this.uploaded = null;
          this.formSnapshot = null;
          this.projectReference = null;
          this.emailBackup = false;
          this.fileStates = this.selectedFiles.map(() => 'waiting');
          renderFiles();
          status.textContent = selectionError() || cooldownMessage() || (hadSession ? this.uploadLabels.selectionChanged : '');
          syncUploadButton();
          this.querySelector('[data-next]').hidden = true;
        };
        input.addEventListener('change', () => {
          if (this.uploadBusy) return;
          this.selectedFiles = Array.from(input.files || []);
          resetSelection();
        });
        form.elements.email.addEventListener('change', () => {
          if (this.uploadBusy) return;
          if (this.uploadSession && this.uploadSession.email.toLowerCase() !== form.elements.email.value.trim().toLowerCase()) resetSelection();
          syncUploadButton();
        });
        backup.addEventListener('click', () => {
          if (this.uploadBusy) return;
          this.emailBackup = true;
          status.textContent = this.uploadLabels.email;
          this.querySelector('[data-next]').hidden = true;
        });
        button.addEventListener('click', () => { this.emailBackup = false; this.uploadFiles(); });
        this.uploadFiles = async () => {
          if (this.uploadBusy || !form.reportValidity()) return false;
          if (cooldownMessage()) { showStatus(cooldownMessage()); return false; }
          const invalid = selectionError();
          if (!this.selectedFiles.length || invalid) {
            showStatus(invalid || this.uploadLabels.chooseFiles); return false;
          }
          this.uploadBusy = true;
          this.uploaded = null;
          this.querySelector('[data-next]').hidden = true;
          const controls = Array.from(form.querySelectorAll('input,select,textarea,button')).map(element => [element, element.disabled]);
          controls.forEach(([element]) => { element.disabled = true; });
          const email = form.elements.email.value.trim();
          const retry = Boolean(this.uploadSession);
          this.uploadSession ||= { id: crypto.randomUUID(), token: crypto.randomUUID(), email };
          this.projectReference = `MP-CUSTOM-${this.uploadSession.id.replaceAll('-', '').toUpperCase()}`;
          const failureKind = (status, data) => {
            const code = data?.code;
            if (status === 429 || code === 'UPLOAD_RATE_LIMIT') return 'rate';
            if (status === 403 || code === 'UPLOAD_SESSION_EXPIRED') return 'session';
            if (status === 503 || code === 'UPLOADS_UNAVAILABLE') return 'unavailable';
            return '';
          };
          const call = async (action, extra = {}) => {
            const response = await fetch(`${this.dataset.uploadEndpoint}${action}`, {
              method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...this.uploadSession, ...extra }), signal: AbortSignal.timeout(120000)
            });
            const data = await response.json().catch(() => ({}));
            const kind = failureKind(response.status, data);
            if (kind) {
              const retryAfter = Math.max(1, Math.min(86400, Number(data.retryAfter) || Number(response.headers.get('Retry-After')) || 60));
              throw Object.assign(new Error(kind), { kind, status: response.status, retryAfter });
            }
            if (!response.ok || data?.ok === false) throw new Error('Upload request failed');
            return data;
          };
          try {
            showStatus(this.uploadLabels.preparing);
            renderFiles();
            const batch = await call('start', { files: this.selectedFiles.map(file => ({ name: file.name, size: file.size })) });
            this.projectReference = batch.reference;
            let cursor = 0, failed = false, failure;
            const setState = (index, state) => {
              this.fileStates[index] = state;
              renderFiles();
              status.textContent = this.uploadLabels.progress.replace('[current]', String(this.fileStates.filter(value => value === 'fileSaved').length)).replace('[total]', String(this.selectedFiles.length));
            };
            const worker = async () => {
              while (!failed && cursor < this.selectedFiles.length) {
                const index = cursor++;
                try {
                  setState(index, retry ? 'checking' : 'transferring');
                  // Fresh sessions cannot already have a file; retries always check Drive first.
                  let confirmed = retry ? await call('file', { index }) : { needsUpload: true };
                  if (!confirmed.uploaded) {
                    if (!batch.files[index].signedUrl) throw new Error('Stored file needs verification before retry');
                    setState(index, 'transferring');
                    const upload = await fetch(batch.files[index].signedUrl, {
                      method: 'PUT', credentials: 'omit', headers: { 'Content-Type': 'application/octet-stream' },
                      body: this.selectedFiles[index], signal: AbortSignal.timeout(180000)
                    });
                    if (!upload.ok && upload.status !== 409) throw new Error('Upload failed');
                    setState(index, 'checking');
                    confirmed = await call('file', { index });
                  }
                  if (!confirmed.uploaded) throw new Error('File not confirmed');
                  setState(index, 'fileSaved');
                } catch (error) {
                  failed = true;
                  if (!failure || error.kind === 'rate') failure = error;
                  setState(index, 'fileError');
                }
              }
            };
            // Wait for both workers, even on failure, before enabling Retry or email backup.
            await Promise.all(Array.from({ length: Math.min(2, this.selectedFiles.length) }, worker));
            if (failed) throw failure || new Error('Some files were not confirmed');
            status.textContent = this.uploadLabels.verifying;
            // Freeze the form once, in page memory. A retry must send the same
            // notification payload, and these values are not written to the database.
            this.formSnapshot ||= {
              name: form.elements.name.value.trim(),
              email,
              service: form.elements.service.value,
              details: form.elements.details.value.trim(),
            };
            this.uploaded = await call('complete', { submission: this.formSnapshot });
            const savedCount = Number(this.uploaded.count);
            status.textContent = (savedCount === 1 ? this.uploadLabels.successOne : this.uploadLabels.success).replace('[count]', String(savedCount)).replace('[reference]', this.uploaded.reference);
            if (this.uploaded.notification === 'unavailable') status.textContent += ` ${this.uploadLabels.notificationError}`;
            return true;
          } catch (error) {
            if (error.kind === 'rate') {
              const retryAfter = Math.max(1, Math.min(86400, Number(error.retryAfter) || 60));
              this.uploadCooldown = { email: email.toLowerCase(), until: Date.now() + retryAfter * 1000 };
              clearTimeout(this.uploadCooldownTimer);
              this.uploadCooldownTimer = setTimeout(() => { if (this.isConnected) syncUploadButton(); }, retryAfter * 1000 + 100);
              showStatus(cooldownMessage() || this.uploadLabels.rateLimit);
            } else if (error.kind === 'session') showStatus(this.uploadLabels.sessionExpired);
            else if (error.kind === 'unavailable') showStatus(this.uploadLabels.uploadsUnavailable);
            else showStatus(this.uploadLabels.error);
            return false;
          } finally {
            this.uploadBusy = false;
            controls.forEach(([element, disabled]) => { element.disabled = disabled; });
            syncUploadButton();
            renderFiles();
          }
        };
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
